import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { REST_CHATS } from '../../../../constants';
import { getRestHeadersGet } from '../../../../helpers/getRestHeadersHelper';
import { Util } from '../../../../../util/util';
import { IRestChat, TChatId } from 'app/types/rest/IRestChat';

//TODO done
export const getByIdRest = (
    id: TChatId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IRestChat>(
            Util.getApiUrl(
                `${REST_CHATS}chat/${id}`),
            getRestHeadersGet(),
        );
    };
    return action;
};
